const config = {}
if (process.env.VUE_APP_ENV) {
    config.env = process.env.VUE_APP_ENV
    config.MAS_TGC = process.env.VUE_APP_MAS_TGC
    config.MIDEA_AUTH = process.env.VUE_APP_MIDEA_AUTH
    config.singlePointLogin = process.env.VUE_APP_LOGIN_URL
    config.staffSelector = {
        url: process.env.VUE_APP_STAFF_SELECTOR_URL,
        project: process.env.VUE_APP_STAFF_SELECTOR_PROJECT,
    }
    config.appId = process.env.VUE_APP_APPID
    config.defaultPage = process.env.VUE_APP_DEFAULT_PAGE
    config.uploadAppId = process.env.VUE_APP_UPLOAD_APP_ID
    config.uploadAppKey = process.env.VUE_APP_UPLOAD_APP_KEY
    config.apiUrl = process.env.VUE_APP_API_URL
    config.apiPath = ''
    config.filePreviewUrl = process.env.VUE_APP_File_Preview
    config.commonBucket = process.env.VUE_APP_COMMON_BUCKET
    config.printUrl = process.env.VUE_APP_PRINT_URL
    config.tenantCode = process.env.VUE_APP_TENANT_CODE
    config.userCode = process.env.VUE_APP_USER_CODE
    config.environment = process.env.VUE_APP_ANNTO_AUTH
    // 大数据监控
    config.bigDataLogTokenUrl = process.env.VUE_APP_BIG_DATA_LOG_TOKEN_URL
    config.bigDataLogUrl = process.env.VUE_APP_BIG_DATA_LOG_URL
    config.bigDataLogAppSecrect = process.env.VUE_APP_BIG_DATA_LOG_APP_SECRECT
    config.bigDataLogAppName = process.env.VUE_APP_BIG_DATA_LOG_APP_NAME
    // feedback组件用
    config.productId = process.env.VUE_APP_PRODUCT_ID
    config.systemId = process.env.VUE_APP_SYSTEM_ID
    config.twoClassifyCode = process.env.VUE_APP_TWO_ClASSIFY_CODE
    config.threeClassifyCode = process.env.VUE_APP_THREE_ClASSIFY_CODE
    config.feedbackAppId = process.env.VUE_APP_FEEDBACK_APPID
    // 数据字典接口路径
    config.dcDictPath = process.env.VUE_APP_DICT_PATH
    // 前端监控
    config.feMonitorAppKey = process.env.VUE_APP_FE_MONITOR_APPKEY
    // DataFinder
    config.dataFinderAppId = Number(process.env.VUE_APP_DATA_FINDER_APP_ID)
    // HTTP field encript key
    config.httpFieldsEncryptKey = process.env.VUE_APP_HTTP_FIELDS_ENCRYPT_KEY
    // 百度地图API秘钥
    config.baiduMapSecretKey = process.env.VUE_APP_BAIDU_MAP_SECRET_KEY
    // 高德地图API秘钥
    config.AMapSecretKey = process.env.VUE_APP_AUTONAVI_MAP_SECRET_KEY
    // 高德地图的securityJsCode
    config.AMapSecurityJsCode = process.env.VUE_APP_AUTONAVI_MAP_SECURITY_JS_CODE
    // Accouting entity
    config.accountingEntityCode = (process.env.VUE_APP_ACCOUNTING_ENTITY || '').split(',').reduce((acc, p) => {
        const [name, code] = p.split(':')
        acc[name] = code
        return acc
    }, Object.create(null))

    // 阿里云构建标识，为 1 时所有路由统一重定向到新门户页面
    config.isAliPage = process.env.VUE_APP_IS_ALI_PAGE
    // 新门户-跳转的登录页面域名
    config.newMainPageLoginDomain = process.env.VUE_APP_NEW_MAIN_PAGE_LOGIN_DOMAIN
} else {
    config.env = 'UAT'
    config.MAS_TGC = 'MAS_TGC_UAT'
    config.MIDEA_AUTH = 'midea_auth_sit'
    config.singlePointLogin = '//signinuat.annto.com?service='
    config.staffSelector = {
        url: 'http://devcloud.midea.com/builder/m_staff_selector-V1.0.1/index.js',
        project: '/mframework',
    }
    config.appId = 'MFRAMEWORK_CLI3.0'
    config.defaultPage = '/index.html'
    config.uploadAppId = '32883248FE8946CCA59DDB36C80BF571'
    config.uploadAppKey = 'Vgjmcgy24Hjwb6Buq7ZfRz0uX2NebGJFrfYDRRPZ'
    config.apiUrl = '/'
    config.apiPath = '/api'
    config.filePreviewUrl = 'http://mipuat.midea.com/'
    config.commonBucket = 'lc_sit'
    config.printUrl = 'https://apiuat.midea.com/'
    config.tenantCode = 'T139775383'
    config.userCode = 'MC714778957'
    config.environment = 'ntp_annto_auth'
    // 大数据监控
    config.bigDataLogTokenUrl = 'https://apisit.midea.com/bigds/token/bigdatatoken'
    config.bigDataLogUrl = 'https://apisit.midea.com/bigds/maidian'
    config.bigDataLogAppSecrect = 'be1f7-asd1-4rvc-b2d0-c46ee3c6893e'
    config.bigDataLogAppName = 'C-NTP'
    // feedback组件用
    config.productId = '9b0653d2-2440-4ed4-9a65-fcefc0353c16'
    config.systemId = 'bdf7cdfc-1d0b-40ae-9952-6ae2cb4db82f'
    config.twoClassifyCode = 'yyyw_tms01'
    config.threeClassifyCode = '0cf4d2b2dd46418d80c24a886e697f43'
    config.feedbackAppId = '0e7799c4d0ff406bb667b3bc60776e3a'
    // 数据字典接口路径
    config.dcDictPath = '/api-ntp/ntp/outter/dcQuery'
    // 前端监控
    config.feMonitorAppKey = '5e8809935e544af094c4866a2652a01a'
    // DataFinder
    config.dataFinderAppId = '10000729'
    // Accouting entity
    config.accountingEntityCode = { TJ: '100013', HN: '1000101' }

    // 阿里云构建标识，为 1 时所有路由统一重定向到新门户页面
    config.isAliPage = ''
    // 新门户-跳转的登录页面域名
    config.newMainPageLoginDomain = ''
}

export default config
